<template>
    <div id="sirki">
        <section class="welcome">
            <div class="bg"><span></span></div>
            <div class="start">
                <h1><span>Творожные сырки в&nbsp;шоколаде: <br><b>больше, чем просто десерт</b></span></h1>
                <div class="text">Нежный творог, свежие кубанские сливки, натуральная ваниль и&nbsp;настоящий шоколад... Творожные сырки 
                в&nbsp;шоколаде&nbsp;&mdash; больше, чем просто десерт. Это удовольствие, в&nbsp;котором не&nbsp;могут себе отказать ни&nbsp;дети, 
                ни&nbsp;взрослые. Утром за&nbsp;завтраком с&nbsp;чашкой крепкого кофе или в&nbsp;течение дня, чтобы поднять настроение. Ассортимент 
                сырков в&nbsp;шоколаде позволяет каждому выбрать свой вкус.</div>
                <h3>Сливки! Творог! Шоколад!</h3>

                <ul>
                    <li>Для любителей нежной воздушной консистенции&nbsp;&mdash; творожные глазированные сырки, мдж 23%. Сочетание нежнейшего творога, свежайших сливок, натуральной ванили и&nbsp;шоколада&nbsp;&mdash; идеальный десерт для романтичных натур, ищущих совершенство в&nbsp;жизни.</li>
                    <li>Поклонники натуральной творожной консистенции, безусловно, остановят свой выбор на&nbsp;глазированных сырках с&nbsp;нежным творожным зерном, мдж 15%. Легкость и&nbsp;неповторимый вкус&nbsp;&mdash; для заряда положительными эмоциями на&nbsp;весь день.</li>
                </ul>
            </div>
            <div class="list">
                <h2>Награды</h2>
                <div class="item item-img1">
                    <div class="item-content">
                        <h3>Сырок творожный в&nbsp;молочном шоколаде</h3>
                        <p>Золотая медаль &laquo;За&nbsp;качество&raquo; и&nbsp;диплом&nbsp;I степени на&nbsp;24-й Международной производственной выставке продуктов питания, напитков и&nbsp;сырья для их&nbsp;производства &laquo;Продэкспо-2017&raquo;, конкурс &laquo;За&nbsp;высокие потребительские свойства товаров&raquo;</p>
                        <div class="image"></div>
                    </div>
                </div>
                <div class="item item-img2">
                    <div class="item-content">
                        <h3>Сырок творожный в&nbsp;темном шоколаде</h3>
                        <p>Золотая медаль &laquo;За&nbsp;качество&raquo; и&nbsp;диплом&nbsp;I степени на&nbsp;24-й Международной производственной выставке продуктов питания, напитков и&nbsp;сырья для их&nbsp;производства &laquo;Продэкспо-2017&raquo;, конкурс &laquo;За&nbsp;высокие потребительские свойcтва товаров&raquo;</p>
                        <div class="image"></div>
                    </div>
                </div>
            </div>
            <div class="lenta">

                <news></news>

                <!--<div class="lenta-logo"></div>-->
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: "Cheesecakes"
    }
</script>
